export class DetailedApiError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor (public code: string, message: string, public details: any) {
    super(message);
  }
}